import React from 'react';

import { getValueByPropPath } from 'Utils/objectHelpers';
import { pluralizeName } from '../../../Order/Renter/Create/TicketOrderItem';

export const SidePanelStalls = ({ children, order }) => {
  const stalls = getValueByPropPath(order, 'reservation.stalls', []);

  const numberOfStalls = `${order.quantity} ${pluralizeName('stall', order.quantity)}`;

  const rows = stalls.reduce((state, item) => {
    const newState = { ...state };
    const group = getValueByPropPath(item, 'building.name', 'none');
    newState[group] = newState[group] !== undefined ? newState[group] + ', ' + item.name : item.name;
    return newState;
  }, {});

  const stallsBuildings = Object.keys(rows).map(key => {
    return (
      <>
        {key}
        <br />{' '}
      </>
    );
  });

  const stallNumbers = Object.keys(rows)
    .map(key => rows[key])
    .join(', ');

  const columns = [
    {
      title: 'LOCATION',
      text: stallsBuildings.length === 0 ? 'Unassigned' : stallsBuildings
    },
    { title: 'STALLS', text: stallNumbers || numberOfStalls }
  ];

  return <>{children(columns)}</>;
};
